import { render, staticRenderFns } from "./licailog.vue?vue&type=template&id=8243691c&scoped=true"
import script from "./licailog.vue?vue&type=script&lang=js"
export * from "./licailog.vue?vue&type=script&lang=js"
import style0 from "./licailog.vue?vue&type=style&index=0&id=8243691c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8243691c",
  null
  
)

export default component.exports